import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { discountsInitialState } from './interfaces';
import { TOrderPayload } from '../../../types/order/TOrderPayload';
import { IDiscountsData } from '../../../ui-toolkit/discounts/types/IDiscounts';

export const discountsReducer = createSlice({
  name: 'discounts',
  initialState: discountsInitialState,
  reducers: {
    setDiscountsAction: (state, action: PayloadAction<TOrderPayload<IDiscountsData[]>>) => {
      state.discounts[action.payload.orderId] = action.payload.value;
    },
    setDiscountsFetchStatusAction: (state, action: PayloadAction<TOrderPayload<IFetchStatus>>) => {
      state.discountsFetchStatus[action.payload.orderId] = action.payload.value;
    },
    setDiscountsErrorAction: (state, action: PayloadAction<TOrderPayload<Error | null>>) => {
      state.discountsError[action.payload.orderId] = action.payload.value;
    },
    setUpdateDiscountsFetchStatusAction: (state, action: PayloadAction<TOrderPayload<IFetchStatus>>) => {
      state.updateDiscountsFetchStatus[action.payload.orderId] = action.payload.value;
    },
    setUpdateDiscountsErrorAction: (state, action: PayloadAction<TOrderPayload<Error | null>>) => {
      state.updateDiscountsError[action.payload.orderId] = action.payload.value;
    },
  },
});
export const {
  setDiscountsAction,
  setDiscountsFetchStatusAction,
  setDiscountsErrorAction,
  setUpdateDiscountsFetchStatusAction,
  setUpdateDiscountsErrorAction,
} = discountsReducer.actions;
